// extracted by mini-css-extract-plugin
export var policyList = "PolicyList-module--policyList--1aMh-";
export var policyBox = "PolicyList-module--policyBox--5WHOY";
export var policyBox__num = "PolicyList-module--policyBox__num--1U_D6";
export var policyBox__cont = "PolicyList-module--policyBox__cont--296Wq";
export var policyBox__ttl = "PolicyList-module--policyBox__ttl--2DM_f";
export var policyBox__text = "PolicyList-module--policyBox__text--32t5x";
export var item = "PolicyList-module--item--2xAax";
export var scroll = "PolicyList-module--scroll--2SWIv";
export var scrollShow = "PolicyList-module--scrollShow--20wtD";